import DividedFooter from '@root/joinroot.com/src/components/footer/divided-footer';
import FooterAddress from '@root/joinroot.com/src/components/footer/footer-address';
import FooterBase from '@root/brand/src/components/footer-base';
import FooterDisclaimer from '@root/brand/src/components/footer-disclaimer';
import FooterIconLinks from '@root/joinroot.com/src/components/footer/footer-icon-links';
import FooterLinks from '@root/joinroot.com/src/components/footer/footer-links';
import PropTypes from '@root/vendor/prop-types';
import Responsive from '@root/core/src/utils/responsive';
import RootLogo from '@root/brand/src/components/root-logo';
import Theme from '@root/joinroot.com/src/components/brand/theme';
import { NavRedesignAbTestBuckets } from '@root/core/src/models/ab-test-buckets';
import { StyleSheet } from '@root/core/src/utils/styles';

export default function Footer({
  navRedesignBucket,
  navRedesignIsLoading,
}) {
  if (!navRedesignIsLoading && navRedesignBucket === NavRedesignAbTestBuckets.SIMPLE_NAV) {
    return <DividedFooter />;
  }

  return (
    <FooterBase>
      <a href={'/'}>
        <RootLogo logoStyles={styles.logo} />
      </a>
      <FooterIconLinks />
      <div css={styles.linksAndAddressContainer}>
        <FooterLinks />
        <FooterAddress />
      </div>
      <FooterDisclaimer
        containerStyles={styles.footerDisclaimer}
        onlyShowCopyright={false}
      />
    </FooterBase>
  );
}

Footer.propTypes = {
  navRedesignBucket: PropTypes.oneOf(Object.values(NavRedesignAbTestBuckets)),
  navRedesignIsLoading: PropTypes.bool,
};

const styles = StyleSheet.create({
  logo: {
    display: 'block',
    marginBottom: 40,
    width: 205,
    height: 'auto',
  },
  linksAndAddressContainer: {
    ...Responsive.md({
      display: 'flex',
      justifyContent: 'space-between',
    }),
  },
  footerDisclaimer: {
    ...Theme.bodyTiny(),
  },
});
